import { useSelector } from 'react-redux';
import { HasPermission } from 'Core/security';
import { PRIVATE_CLIP_PERMISSION } from '../utils/constants';

export const usePrivateClipPermission = () => {
  const user = useSelector((state) => state.securityRedux.user);
  return HasPermission(user, PRIVATE_CLIP_PERMISSION.names, PRIVATE_CLIP_PERMISSION.subuser);
};
